import agents from './agents'

const suggestions = {
  header: 'Sugestões para começar',
  byAgent: {
    [agents.GOVERNANCE_PROJECT_COPILOT_AGENT]: [
      {
        label: 'Como funciona este controle?',
        question: 'Como funciona este controle?',
      },
      {
        label: 'Como implemento este controle?',
        question: 'Como implemento este controle?',
      },
      {
        label: 'Quais evidências preciso reunir?',
        question: 'Quais evidências preciso reunir?',
      },
      {
        label: 'Que documentos preciso ter?',
        question: 'Que documentos preciso ter?',
      },
      {
        label: 'O que o auditor vai verificar aqui?',
        question: 'O que o auditor vai verificar aqui?',
      },
      {
        label: 'Quais os erros mais comuns neste controle?',
        question: 'Quais os erros mais comuns neste controle?',
      },
    ],
  },
}

export default suggestions
